/* eslint-disable
    consistent-return,
    new-cap
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import {queue} from 'd3-queue';
import _ from 'underscore';
import React from 'react';

import {assert} from 'Asserts';
import notifications from 'notifications';
import DragDropUpload from 'util/DragDropUpload';
import FilesPickerTemplate from './FilesPickerTemplate';
import FilesPickerItemTemplate from './FilesPickerItemTemplate';

const STATUS = {
  UPLOADING: 'uploading',
  COMPLETE: 'complete',
  FAILED: 'failed',
  PENDING: 'pending',
};

class UploadFileModel extends Backbone.Model {
  defaults() {
    return {
      file: null,
      name: 'Untited',
      status: STATUS.PENDING,
      deleted: false,
    };
  }

  upload() {
    this.set({status: STATUS.UPLOADING});
    return this.get('upload')(this.get('file'), this.get('name'));
  }
}

class UploadFileView extends Backbone.View {
  static initClass() {
    this.prototype.template = FilesPickerItemTemplate;
    this.prototype.tagName = 'tr';

    this.prototype.events = {
      'click .delete': 'handleDelete',
    };
  }

  initialize() {
    this.listenTo(this.model, 'change:deleted', () => {
      if (this.shouldRemove()) {
        return this.remove();
      }
    });
    this.listenTo(this.model, 'change:name change:status', () => this.render());
  }

  render() {
    this.$el.html(
      this.template({
        name: this.model.get('name'),
        status: this.model.get('status'),
      })
    );
    return this;
  }

  handleDelete() {
    this.model.set('deleted', true);
  }

  shouldRemove() {
    return this.model.get('status') === STATUS.PENDING && this.model.get('deleted');
  }
}
UploadFileView.initClass();

class FilesPicker extends Backbone.View {
  static initClass() {
    this.prototype.tagName = 'div';
    this.prototype.className = 'files-picker';
    this.prototype.template = FilesPickerTemplate;
    this.prototype.events = {
      'click .file-choose': 'chooseFiles',
      'change .file': 'addFromChooser',
      filedrop: 'handleDrop',
    };
  }

  initialize(options) {
    this.handleUpload = this.handleUpload.bind(this);
    // eslint-disable-next-line no-restricted-syntax
    options = _.extend(
      {
        getName(file) {
          return file.name;
        },
        multiple: true,
        parallelism: 2,
        bulkUpload: false,
      },
      options
    );
    super.initialize(options);
    if (this.collection == null) {
      this.collection = new Backbone.Collection([], UploadFileModel);
    }

    this.listenTo(this.collection, 'change:deleted', (model, deleted) => {
      assert(deleted);
      this.collection.remove(model);
      this.$('.js-files-count').text(this.collection.length);
    });

    ({
      isDisabled: this.isDisabled,
      getName: this.getName,
      multiple: this.multiple,
      bulkUpload: this.bulkUpload,
      parallelism: this.parallelism,
      upload: this.upload,
      maxFiles: this.maxFiles,
      fileTypes: this.fileTypes,
    } = options);
  }

  handleDrop(e, files) {
    if (!this.isDisabled && files.length > 0) {
      this.addFiles(files);
    }
  }

  chooseFiles() {
    return this.$('.file').click();
  }

  addFromChooser(e) {
    return this.addFiles(e.target.files);
  }

  addFiles(files) {
    return (() => {
      const remaining = this.maxFiles != null ? this.maxFiles - this.collection.length : null;
      if (remaining != null && Array.from(files).length > remaining) {
        let msg = (
          <>
            You've exceeded the limit of <strong>{this.maxFiles} files</strong>.
          </>
        );
        if (remaining > 0) {
          msg = (
            <>
              {msg} Please try your action again but add{' '}
              <strong>no more than {remaining} additional files</strong>.
            </>
          );
        }
        notifications.warn(msg);
        return;
      }
      const result = [];
      for (const file of Array.from(files)) {
        const name = this.getName(file);
        const uploadModel = new UploadFileModel({file, name, upload: this.upload});
        result.push(this.registerUpload(uploadModel));
      }
      return result;
    })();
  }

  registerUpload(uploadModel) {
    this.$('.files-list').append(new UploadFileView({model: uploadModel}).render().el);
    this.$('.js-files-title').removeClass('hidden').attr('aria-hidden', false);
    if (!this.multiple) {
      // If single file upload, then remove the other existing files.
      this.collection.each((model) => {
        model.set('deleted', true);
      });
    }
    this.collection.add(uploadModel);
    this.$('.js-files-count').text(this.collection.length);
  }

  handleUpload({uploadComplete, allComplete}) {
    DragDropUpload.pop(this.el);
    this.$('.file-choose').addClass('disabled');

    return this.bulkUpload
      ? this.handleBulkUpload({allComplete})
      : this.handleSerialUpload({uploadComplete, allComplete});
  }

  handleSerialUpload({uploadComplete, allComplete}) {
    assert(_.isFunction(uploadComplete) && _.isFunction(allComplete));
    const uploadQueue = new queue(this.parallelism);

    function task(uploadModel, callback) {
      if (uploadModel.get('deleted')) {
        callback();
        return;
      }
      uploadModel
        .upload()
        .done(() => uploadModel.set('status', STATUS.COMPLETE))
        .fail(() => uploadModel.set('status', STATUS.FAILED))
        .done((response) => uploadComplete(response, uploadModel.get('file').name))
        .always(() => callback());
    }

    this.collection.each((model) => {
      uploadQueue.defer(task, model);
    });
    uploadQueue.awaitAll(() => allComplete());
  }

  setAllFilesStatus(status) {
    this.collection.each((model) => model.set({status}));
  }

  handleBulkUpload({allComplete}) {
    assert(_.isFunction(allComplete));
    this.setAllFilesStatus(STATUS.UPLOADING);
    const uploadPromise = this.upload(this.collection.map((model) => model.get('file')));
    // If this fails, make sure your `upload` prop returns a JQuery promise
    assert(uploadPromise != null, 'Upload handler should return a promise');
    return uploadPromise
      .fail(() => this.setAllFilesStatus(STATUS.FAILED))
      .done(() => this.setAllFilesStatus(STATUS.COMPLETE))
      .done(() => allComplete());
  }

  remove() {
    DragDropUpload.pop(this.el);
    return super.remove();
  }

  render() {
    this.$el.html(
      this.template({isDisabled: this.isDisabled, multiple: this.multiple, fileTypes: this.fileTypes})
    );
    DragDropUpload.push(this.el);
    return this;
  }
}
FilesPicker.initClass();

export default FilesPicker;
